import React from 'react';
import { CheckboxListSelector } from 'src/design/molecules/CheckboxListSelector';

interface CostCodeSelectorProps {
  onChange: (codes: string[]) => void;
  value: string[];
  options: string[];
  disabled?: boolean;
}

export const CostCodeSelector: React.FC<CostCodeSelectorProps> = ({
  onChange,
  value,
  options,
  disabled = false,
}) => {
  return (
    <CheckboxListSelector
      items={options}
      value={value}
      onChange={onChange}
      getItemLabel={(item) => item}
      getItemId={(item) => item}
      label="Cost Codes"
      searchPlaceholder="Search cost codes..."
      disabled={disabled}
      storageKey="manhours-cost-code-selector"
      defaultToAll
    />
  );
};
